// eslint-disable-next-line

module.exports = {
  isplainnumber(value) {
    return (/^[0-9]*$/).test(value);
  },
  containsonlylanguagechars(value) {
    return (/^[a-zA-ZÀ-ÿ\s.-]+$/).test(value);
  },
};